export default class Bg_bubble {
  constructor() {
    this.renderer = '';
    this.stage = '';
    this.container = [];
    this.ww = window.innerWidth;
    this.wh = window.innerHeight;
    this.device_scale = (window.innerWidth < 768) ? 0.6 : 1;

    this.init();
  }

  init() {
    this.initPixi();
    this.generateBubbleContainer();
    this.ticker();
  }

  initPixi() {
    let ratio = 1;
    const that = this;

    const rendererOptions = {
      antialias: true,
      transparent: true,
      autoResize: true,
      resolution: window.devicePixelRatio
    }

    this.renderer = PIXI.autoDetectRenderer(this.ww, this.wh, rendererOptions);
    this.stage = new PIXI.Container();

    // Add canvas to the HTML
    document.body.insertBefore(this.renderer.view, document.body.firstChild);

    // Enable Interactions
    this.stage.interactive = true;

    // Size the renderer to fill the screen
    resize();


    window.addEventListener("resize", resize);


    function resize() {

      // // Determine which screen dimension is most constrained
      // ratio = Math.min(window.innerWidth / that.ww,
      //   window.innerHeight / that.wh);

      // // Scale the view appropriately to fill that dimension
      // that.stage.scale.x = that.stage.scale.y = ratio;

      // // Update the renderer dimensions
      // that.renderer.resize(Math.ceil(that.ww * ratio),
      //   Math.ceil(that.wh * ratio));

      that.ww = window.innerWidth;
      that.wh = window.innerHeight;

      that.renderer.resize(that.ww, that.wh);
      that.resetContainerPos(); //泡のxの再設定
    }


  }

  randRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  generateBubbleContainer() {

    let container_option = [
      { x: this.ww * 0.1, y: this.wh * Math.random() },
      { x: this.ww * 0.9, y: this.wh * Math.random() },
    ]


    for (let i = 0; i < container_option.length; i++) {
      this.generateBubble(container_option[i]);
    }
  }


  resetContainerPos() {
    for (let i = 0; i < this.container.length; i++) {
      this.container[i].x = (i == 0) ? this.ww * 0.1 : this.ww * 0.9;
    }
  }



  generateBubble(container_option) {

    const container = new PIXI.Container();
    container.width = 100;
    container.height = 400;
    container.x = container_option.x;
    container.y = container_option.y;
    container.bubbles = [];
    container.degree = 0;
    container.alpha = 0;



    const sprites = [
      { src: '/wp/wp-content/themes/blue1993/assets/img/common/bg/ph_bubble_29x29.png', wh: 25 * this.device_scale, x: 0, y: 0 },
      { src: '/wp/wp-content/themes/blue1993/assets/img/common/bg/ph_bubble_15x15.png', wh: 14 * this.device_scale, x: 10 * this.device_scale, y: 30 * this.device_scale },
      { src: '/wp/wp-content/themes/blue1993/assets/img/common/bg/ph_bubble_11x11.png', wh: 10 * this.device_scale, x: 0, y: 50 * this.device_scale },
      { src: '/wp/wp-content/themes/blue1993/assets/img/common/bg/ph_bubble_23x23.png', wh: 20 * this.device_scale, x: 10 * this.device_scale, y: 70 * this.device_scale },
      { src: '/wp/wp-content/themes/blue1993/assets/img/common/bg/ph_bubble_15x15.png', wh: 14 * this.device_scale, x: 0, y: 90 * this.device_scale },
      { src: '/wp/wp-content/themes/blue1993/assets/img/common/bg/ph_bubble_11x11.png', wh: 10 * this.device_scale, x: 20 * this.device_scale, y: 110 * this.device_scale },
      { src: '/wp/wp-content/themes/blue1993/assets/img/common/bg/ph_bubble_23x23.png', wh: 20 * this.device_scale, x: 10 * this.device_scale, y: 150 * this.device_scale },
      { src: '/wp/wp-content/themes/blue1993/assets/img/common/bg/ph_bubble_15x15.png', wh: 10 * this.device_scale, x: 0, y: 170 * this.device_scale }
    ]

    //コンテナ内の泡を生成
    for (let i = 0; i < sprites.length; i++) {
      let bubble = new PIXI.Sprite.fromImage(sprites[i].src);
      bubble.x = sprites[i].x;
      bubble.y = sprites[i].y;
      bubble.width = sprites[i].wh;
      bubble.height = sprites[i].wh;
      bubble.degree = 360 * Math.random();

      container.bubbles.push(bubble);
      container.addChild(bubble);
    }

    //コンテナをステージに追加
    this.container.push(container);
    this.stage.addChild(container);
  }


  //コンテナと中の泡のムーブ
  moveBubble() {


    for (let i = 0; i < this.container.length; i++) {
      const container = this.container[i];
      container.degree += 10 + (i * 10);
      container.y += -2;
      let c_rad = (container.degree * Math.PI) / 180;
      container.alpha = Math.sin(c_rad / 30);

      if (container.y + container.height < 0) {
        container.y = this.wh;
      }

      for (let k = 0; k < container.bubbles.length; k++) {
        let bubble = container.bubbles[k];
        bubble.degree += 15;
        let rad = (bubble.degree * Math.PI) / 180;
        bubble.x += Math.sin(rad) * 1.25;

      }


    }
  }

  ticker() {
    var ticker = new PIXI.ticker.Ticker();
    var that = this;

    ticker.autoStart = true;

    ticker.add(function (delta) {
      that.moveBubble();
      that.renderer.render(that.stage);
    });
  }
}
